<script>
    import PricingPlanButton from "../../components/payment/PricingPlanButton.svelte";

    import { onMount } from "svelte";
    import { TenantStore } from "../../stores/TenantStore";
    import { getEffectivePricingPlan } from "../../utils/Utils";
    import { formattedDate } from "../../utils/date";
    import { GiftStore } from "../../stores/GiftStore";
    import { AppStore, Panels } from "../../stores/AppStore";
    import { clickAction } from "$/utils/clickAction";
    import PricingPlanButtonPaddle from "$/components/payment/PricingPlanButtonPaddle.svelte";

    let paymentPlan = "Monthly";

    let pricePro;
    let discountPricePro;

    $: activePlan = getEffectivePricingPlan($TenantStore?.active);
    $: activePlanName =
        $TenantStore === null
            ? "Loading..."
            : activePlan === 0
              ? "Personal"
              : activePlan === 1
                ? "Personal Pro"
                : "Team";

    let prices = {
        Personal: 0,
        "Personal Pro Monthly": 15,
        "Personal Pro Annually": 132,
    };

    let discount = 0.65;

    const features = {
        "Workspace Contributors": {
            Personal: "1 seat",
            "Personal Pro": "1 seat",
            Team: "3 seats",
        },
        "Unlimited shareable topics": {
            Personal: true,
            "Personal Pro": true,
            Team: true,
        },
        "Unlimited higlights & comments": {
            Personal: true,
            "Personal Pro": true,
            Team: true,
        },
        "Topic-level access roles": {
            Personal: true,
            "Personal Pro": true,
            Team: true,
        },
        "Import from Kindle": {
            Personal: true,
            "Personal Pro": true,
            Team: true,
        },
        "Topic Clusters": {
            Personal: "5",
            "Personal Pro": "Unlimited",
            Team: "Unlimited",
        },
        "Topic & Cluster Contributors": {
            Personal: "5",
            "Personal Pro": "Unlimited",
            Team: "Unlimited",
        },
        "Contributor-level access roles": {
            Personal: true,
            "Personal Pro": true,
            Team: true,
        },
        "Upload PDFs": {
            Personal: true,
            "Personal Pro": true,
            Team: true,
        },
        "PDF size limit": {
            Personal: "2MB",
            "Personal Pro": "30MB",
            Team: "30MB",
        },
        "Topic history": {
            Personal: "30 days",
            "Personal Pro": "Unlimited",
            Team: "Unlimited",
        },
        "Export PDF & Print topics": {
            Personal: true,
            "Personal Pro": true,
            Team: true,
        },
        "Advanced search": {
            Personal: false,
            "Personal Pro": true,
            Team: true,
        },
        "Priority support": {
            Personal: false,
            "Personal Pro": true,
            Team: true,
        },
        "Additional Seats": {
            Personal: false,
            "Personal Pro": false,
            Team: "+$15 per seat",
        },
        "AI Copilot": {
            Personal: false,
            "Personal Pro": false,
            Team: true,
        },
        "Workspace-level access roles": {
            Personal: false,
            "Personal Pro": false,
            Team: true,
        },
        "Single Sign-on Support": {
            comingSoon: true,
            Personal: false,
            "Personal Pro": false,
            Team: true,
        },
    };

    function getPricePro() {
        let price = prices[`Personal Pro ${paymentPlan}`];

        if (paymentPlan === "Annually") {
            let discountPrice = price - price * discount;
            pricePro = `$${price}/year`;
            discountPricePro = `$${discountPrice}/year`;
        } else {
            pricePro = `$${price}/month`;
        }
    }

    function togglePaymentPlan() {
        if (paymentPlan === "Annually") {
            paymentPlan = "Monthly";
        } else {
            paymentPlan = "Annually";
        }
        getPricePro();
    }

    onMount(() => {
        getPricePro();
    });
</script>

<div class="price-modal">
    <div id="detailed-pricing" class="price-modal-table-wrapper">
        <div class="price-modal-table">
            <div class="price-modal-table__header">
                <div class="price-modal-table__header-info">
                    <h1>Plans & features</h1>
                    <span class="pricing-plan-badge" on:click={() => AppStore.togglePanel(Panels.WORKSPACE)}>
                        <svg
                            class="pricing-plan-badge__icon"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke-width="1.5"
                            stroke="currentColor"
                        >
                            <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                d="M3.75 21h16.5M4.5 3h15M5.25 3v18m13.5-18v18M9 6.75h1.5m-1.5 3h1.5m-1.5 3h1.5m3-6H15m-1.5 3H15m-1.5 3H15M9 21v-3.375c0-.621.504-1.125 1.125-1.125h3.75c.621 0 1.125.504 1.125 1.125V21"
                            />
                        </svg>
                        <span class="pricing-plan-badge__name"
                            >{activePlanName}</span
                        >
                        <span class="pricing-plan-badge__exp">
                            {#if $TenantStore !== null}
                                {#if activePlan === 0}
                                    Free Forever
                                {:else if $TenantStore?.active.lifetime}
                                    <span
                                        class="pricing-plan-badge__exp__lifetime"
                                    >
                                        Lifetime
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            stroke-width="1.5"
                                            stroke="currentColor"
                                        >
                                            <path
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                d="M21 11.25v8.25a1.5 1.5 0 01-1.5 1.5H5.25a1.5 1.5 0 01-1.5-1.5v-8.25M12 4.875A2.625 2.625 0 109.375 7.5H12m0-2.625V7.5m0-2.625A2.625 2.625 0 1114.625 7.5H12m0 0V21m-8.625-9.75h18c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125h-18c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125z"
                                            />
                                        </svg>
                                    </span>
                                {:else if TenantStore.isExpired()}
                                    <span
                                        class="pricing-plan-badge__exp__lifetime"
                                    >
                                        Expired
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            stroke-width="1.5"
                                            stroke="currentColor"
                                        >
                                            <path
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                d="M15.182 16.318A4.486 4.486 0 0 0 12.016 15a4.486 4.486 0 0 0-3.198 1.318M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0ZM9.75 9.75c0 .414-.168.75-.375.75S9 10.164 9 9.75 9.168 9 9.375 9s.375.336.375.75Zm-.375 0h.008v.015h-.008V9.75Zm5.625 0c0 .414-.168.75-.375.75s-.375-.336-.375-.75.168-.75.375-.75.375.336.375.75Zm-.375 0h.008v.015h-.008V9.75Z"
                                            />
                                        </svg>
                                    </span>
                                {:else if activePlan > 0}
                                    {TenantStore.isExpiring() ? "Exp." : "Ren."}
                                    {formattedDate(
                                        $TenantStore?.active?.expirationDate,
                                    )}
                                {/if}
                            {/if}
                        </span>
                    </span>

                    {#if $TenantStore?.active?.lifetime}
                        <span class="pricing-plan-explanation">
                            You have {activePlanName} for lifetime, you'll never
                            be charged
                        </span>
                    {/if}
                </div>
                <div class="price-modal-table__header-cell">
                    <h2 class="price-modal-table__header-plan">Personal</h2>
                    <span class="price-modal-table__header-price"> $0 </span>
                    <span class="price-modal-table__header-subscription">
                        Free forever
                    </span>
                </div>
                <div class="price-modal-table__header-cell">
                    <h2 class="price-modal-table__header-plan">Personal Pro</h2>
                    <span class="price-modal-table__header-price">
                        {#if paymentPlan === "Annually"}
                            $100
                        {:else}
                            $10
                        {/if}
                    </span>
                    <span class="price-modal-table__header-subscription">
                        {#if paymentPlan === "Annually"}
                            /year
                        {:else}
                            /month
                        {/if}
                    </span>

                    <!-- {#if discount > 0 && paymentPlan === 'Annually'}
                        <span class="line-through">{pricePro}</span>
                        <br/>
                        {discountPricePro}
                        <br/>
                        <span class="price-modal-table__header__discount">Save {discount * 100}%</span>
                    {:else}
                        {pricePro}
                    {/if} -->
                </div>
                <div class="price-modal-table__header-cell">
                    <h2 class="price-modal-table__header-plan">Team</h2>
                    <span class="price-modal-table__header-price">
                        {#if paymentPlan === "Annually"}
                            $150
                        {:else}
                            $15
                        {/if}
                    </span>
                    <span class="price-modal-table__header-subscription">
                        {#if paymentPlan === "Annually"}
                            /year
                        {:else}
                            /month
                        {/if}
                    </span>
                </div>
            </div>
            <div class="price-modal-feature">
                <div
                    class="subscription-type"
                    use:clickAction={togglePaymentPlan}
                >
                    <span
                        class="subscription-type__switch"
                        class:subscription-type__switch--active={paymentPlan ===
                            "Annually"}
                    >
                        {paymentPlan}
                    </span>
                    <div class="subscription-type__placeholder">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke-width="1.5"
                            stroke="currentColor"
                            class="h-4 w-4"
                        >
                            <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5m-9-6h.008v.008H12v-.008ZM12 15h.008v.008H12V15Zm0 2.25h.008v.008H12v-.008ZM9.75 15h.008v.008H9.75V15Zm0 2.25h.008v.008H9.75v-.008ZM7.5 15h.008v.008H7.5V15Zm0 2.25h.008v.008H7.5v-.008Zm6.75-4.5h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V15Zm0 2.25h.008v.008h-.008v-.008Zm2.25-4.5h.008v.008H16.5v-.008Zm0 2.25h.008v.008H16.5V15Z"
                            />
                        </svg>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke-width="1.5"
                            stroke="currentColor"
                            class="h-4 w-4"
                        >
                            <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5"
                            />
                        </svg>
                    </div>
                </div>
                <div class="flex">
                    <PricingPlanButtonPaddle
                        plan={0}
                        isLoading={$TenantStore === null}
                    ></PricingPlanButtonPaddle>
                </div>
                <div class="flex">
                    <PricingPlanButtonPaddle
                        plan={1}
                        isLoading={$TenantStore === null}
                        expirationDate={$TenantStore?.active.expirationDate}
                        status={$TenantStore?.active?.subscription?.status}
                        isAnnual={paymentPlan === "Annually"}
                    ></PricingPlanButtonPaddle>
                </div>
                <div class="flex">
                    <PricingPlanButtonPaddle
                        plan={2}
                        isLoading={$TenantStore === null}
                        expirationDate={$TenantStore?.active.expirationDate}
                        status={$TenantStore?.active?.subscription?.status}
                        isAnnual={paymentPlan === "Annually"}
                    ></PricingPlanButtonPaddle>
                </div>
            </div>

            {#if GiftStore.getProGifts($GiftStore).length > 0 && $TenantStore?.active?.personal}
                <div class="price-modal-feature">
                    <div class="price-modal-feature__name">Share love</div>
                    <div class="price-modal-feature__cell">
                        <span
                            class="pricing-plan-badge price-modal-feature__cell--clickable"
                            use:clickAction={() =>
                                ($AppStore.panel = Panels.INVITATION)}
                        >
                            <svg
                                class="pricing-plan-badge__icon"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke-width="1.5"
                                stroke="currentColor"
                            >
                                <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    d="M6 12L3.269 3.126A59.768 59.768 0 0121.485 12 59.77 59.77 0 013.27 20.876L5.999 12zm0 0h7.5"
                                />
                            </svg>
                            <span class="pricing-plan-badge__name"
                                >Invite Friends</span
                            >
                            <!-- <span class="pricing-plan-badge__exp">
                                <span class="pricing-plan-badge__exp__lifetime">
                                    Unlimited
                                </span>
                            </span> -->
                        </span>
                    </div>
                    <div class="price-modal-feature__cell">
                        {#if GiftStore.getProGifts($GiftStore).length > 0}
                            <span
                                class="pricing-plan-badge price-modal-feature__cell--clickable"
                                use:clickAction={() =>
                                    ($AppStore.panel = Panels.INVITATION)}
                            >
                                <svg
                                    class="pricing-plan-badge__icon"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke-width="1.5"
                                    stroke="currentColor"
                                >
                                    <path
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        d="M21 11.25v8.25a1.5 1.5 0 01-1.5 1.5H5.25a1.5 1.5 0 01-1.5-1.5v-8.25M12 4.875A2.625 2.625 0 109.375 7.5H12m0-2.625V7.5m0-2.625A2.625 2.625 0 1114.625 7.5H12m0 0V21m-8.625-9.75h18c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125h-18c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125z"
                                    />
                                </svg>
                                <span class="pricing-plan-badge__name"
                                    >Gift PRO</span
                                >
                                <span class="pricing-plan-badge__exp">
                                    <span
                                        class="pricing-plan-badge__exp__lifetime"
                                    >
                                        {GiftStore.getSentProGifts($GiftStore)
                                            .length} / {GiftStore.getProGifts(
                                            $GiftStore,
                                        ).length}
                                    </span>
                                </span>
                            </span>
                        {:else if $GiftStore === null}
                            <span
                                class="pricing-plan-badge price-modal-feature__cell--clickable"
                                use:clickAction={() =>
                                    ($AppStore.panel = Panels.INVITATION)}
                            >
                                <svg
                                    class="pricing-plan-badge__icon"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke-width="1.5"
                                    stroke="currentColor"
                                >
                                    <path
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        d="M21 11.25v8.25a1.5 1.5 0 01-1.5 1.5H5.25a1.5 1.5 0 01-1.5-1.5v-8.25M12 4.875A2.625 2.625 0 109.375 7.5H12m0-2.625V7.5m0-2.625A2.625 2.625 0 1114.625 7.5H12m0 0V21m-8.625-9.75h18c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125h-18c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125z"
                                    />
                                </svg>
                                <span class="pricing-plan-badge__name"
                                    >Loading...</span
                                >
                            </span>
                        {:else}
                            <span
                                class="pricing-plan-badge price-modal-feature__cell--clickable"
                                use:clickAction={() =>
                                    ($AppStore.panel = Panels.INVITATION)}
                            >
                                <svg
                                    class="pricing-plan-badge__icon"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke-width="1.5"
                                    stroke="currentColor"
                                >
                                    <path
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        d="M21 11.25v8.25a1.5 1.5 0 01-1.5 1.5H5.25a1.5 1.5 0 01-1.5-1.5v-8.25M12 4.875A2.625 2.625 0 109.375 7.5H12m0-2.625V7.5m0-2.625A2.625 2.625 0 1114.625 7.5H12m0 0V21m-8.625-9.75h18c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125h-18c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125z"
                                    />
                                </svg>
                                <span class="pricing-plan-badge__name"
                                    >Not available</span
                                >
                            </span>
                        {/if}
                    </div>
                    <div class="price-modal-feature__cell">
                        <svg
                            class="h-5 w-5 text-gray-300"
                            aria-hidden="true"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                            xmlns="http://www.w3.org/2000/svg"
                            ><path
                                fill-rule="evenodd"
                                d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                                clip-rule="evenodd"
                            ></path></svg
                        >

                        {#if false}
                            <!-- We still do not have an affiliate network -->
                            <span class="pricing-plan-badge">
                                <svg
                                    class="pricing-plan-badge__icon"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke-width="1.5"
                                    stroke="currentColor"
                                >
                                    <path
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        d="M20.25 14.15v4.25c0 1.094-.787 2.036-1.872 2.18-2.087.277-4.216.42-6.378.42s-4.291-.143-6.378-.42c-1.085-.144-1.872-1.086-1.872-2.18v-4.25m16.5 0a2.18 2.18 0 00.75-1.661V8.706c0-1.081-.768-2.015-1.837-2.175a48.114 48.114 0 00-3.413-.387m4.5 8.006c-.194.165-.42.295-.673.38A23.978 23.978 0 0112 15.75c-2.648 0-5.195-.429-7.577-1.22a2.016 2.016 0 01-.673-.38m0 0A2.18 2.18 0 013 12.489V8.706c0-1.081.768-2.015 1.837-2.175a48.111 48.111 0 013.413-.387m7.5 0V5.25A2.25 2.25 0 0013.5 3h-3a2.25 2.25 0 00-2.25 2.25v.894m7.5 0a48.667 48.667 0 00-7.5 0M12 12.75h.008v.008H12v-.008z"
                                    />
                                </svg>
                                <span class="pricing-plan-badge__name"
                                    >Become affiliate</span
                                >
                            </span>
                        {/if}
                    </div>
                </div>
            {/if}
            {#each Object.keys(features) as feature, index}
                <div class="price-modal-feature">
                    <div class="price-modal-feature__name">
                        {feature}
                        {#if features[feature]["comingSoon"]}
                            <span class="price-modal-feature__comming-soon"
                                >COMING SOON</span
                            >
                        {/if}
                    </div>
                    <div class="price-modal-feature__cell">
                        {#if features[feature]["Personal"] === true}
                            <svg
                                class="h-5 w-5 text-pink-600"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                fill="currentColor"
                            >
                                <path
                                    d="m11.645 20.91-.007-.003-.022-.012a15.247 15.247 0 0 1-.383-.218 25.18 25.18 0 0 1-4.244-3.17C4.688 15.36 2.25 12.174 2.25 8.25 2.25 5.322 4.714 3 7.688 3A5.5 5.5 0 0 1 12 5.052 5.5 5.5 0 0 1 16.313 3c2.973 0 5.437 2.322 5.437 5.25 0 3.925-2.438 7.111-4.739 9.256a25.175 25.175 0 0 1-4.244 3.17 15.247 15.247 0 0 1-.383.219l-.022.012-.007.004-.003.001a.752.752 0 0 1-.704 0l-.003-.001Z"
                                />
                            </svg>
                        {:else if features[feature]["Personal"] === false}
                            <svg
                                class="h-5 w-5 text-gray-300"
                                aria-hidden="true"
                                fill="currentColor"
                                viewBox="0 0 20 20"
                                xmlns="http://www.w3.org/2000/svg"
                                ><path
                                    fill-rule="evenodd"
                                    d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                                    clip-rule="evenodd"
                                ></path></svg
                            >
                        {:else}
                            {features[feature]["Personal"]}
                        {/if}
                    </div>
                    <div class="price-modal-feature__cell">
                        {#if features[feature]["Personal Pro"] === true}
                            <svg
                                class="h-5 w-5 text-pink-600"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                fill="currentColor"
                            >
                                <path
                                    d="m11.645 20.91-.007-.003-.022-.012a15.247 15.247 0 0 1-.383-.218 25.18 25.18 0 0 1-4.244-3.17C4.688 15.36 2.25 12.174 2.25 8.25 2.25 5.322 4.714 3 7.688 3A5.5 5.5 0 0 1 12 5.052 5.5 5.5 0 0 1 16.313 3c2.973 0 5.437 2.322 5.437 5.25 0 3.925-2.438 7.111-4.739 9.256a25.175 25.175 0 0 1-4.244 3.17 15.247 15.247 0 0 1-.383.219l-.022.012-.007.004-.003.001a.752.752 0 0 1-.704 0l-.003-.001Z"
                                />
                            </svg>
                        {:else if features[feature]["Personal Pro"] === false}
                            <svg
                                class="h-5 w-5 text-gray-300"
                                aria-hidden="true"
                                fill="currentColor"
                                viewBox="0 0 20 20"
                                xmlns="http://www.w3.org/2000/svg"
                                ><path
                                    fill-rule="evenodd"
                                    d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                                    clip-rule="evenodd"
                                ></path></svg
                            >
                        {:else}
                            {features[feature]["Personal Pro"]}
                        {/if}
                    </div>
                    <div class="price-modal-feature__cell">
                        {#if features[feature]["Team"] === true}
                            <svg
                                class="h-5 w-5 text-pink-600"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                fill="currentColor"
                            >
                                <path
                                    d="m11.645 20.91-.007-.003-.022-.012a15.247 15.247 0 0 1-.383-.218 25.18 25.18 0 0 1-4.244-3.17C4.688 15.36 2.25 12.174 2.25 8.25 2.25 5.322 4.714 3 7.688 3A5.5 5.5 0 0 1 12 5.052 5.5 5.5 0 0 1 16.313 3c2.973 0 5.437 2.322 5.437 5.25 0 3.925-2.438 7.111-4.739 9.256a25.175 25.175 0 0 1-4.244 3.17 15.247 15.247 0 0 1-.383.219l-.022.012-.007.004-.003.001a.752.752 0 0 1-.704 0l-.003-.001Z"
                                />
                            </svg>
                        {:else if features[feature]["Team"] !== false}
                            {features[feature]["Team"]}
                        {/if}
                    </div>
                </div>
            {/each}

            <div class="legal-documents">
                <a
                    target="_blank"
                    rel="noreferrer"
                    href="https://collabwriting.com/legal/refund-policy"
                    >Refund Policy</a
                >•
                <a
                    target="_blank"
                    rel="noreferrer"
                    href="https://collabwriting.com/legal/terms-of-service"
                    >Terms of Service</a
                >•
                <a
                    target="_blank"
                    rel="noreferrer"
                    href="https://collabwriting.com/legal/privacy-policy"
                    >Privacy Policy</a
                >•
                <a
                    target="_blank"
                    rel="noreferrer"
                    href="https://collabwriting.com/legal/acceptable-use-policy"
                    >Acceptable Use Policy</a
                >
            </div>
        </div>
    </div>
</div>

<style>
    .price-modal {
        @apply relative flex w-full flex-col overflow-auto bg-white;
    }

    .legal-documents {
        @apply mt-auto flex w-full flex-row items-center justify-center gap-2 bg-gray-100 p-4 text-xs text-gray-500;
    }
    .legal-documents a {
        @apply hover:text-black hover:underline;
    }

    .price-modal-table {
        @apply flex h-full min-w-[680px] flex-col lg:min-w-full;
    }
    .price-modal-table-wrapper {
        @apply w-full flex-grow;
    }

    .price-modal-table__header-info {
        @apply flex flex-col items-start justify-center gap-2 pl-4;
    }
    .price-modal-table__header-info h1 {
        @apply text-2xl font-bold;
    }

    .pricing-plan-badge {
        @apply flex flex-row flex-wrap items-center justify-center rounded-3xl border border-solid bg-white px-2 py-1 text-sm text-black hover:bg-yellow-100 cursor-pointer;
    }
    .pricing-plan-badge__name {
        @apply mx-1 text-center text-sm;
    }
    .pricing-plan-badge__icon {
        @apply mr-1 h-4 w-4;
    }
    .pricing-plan-badge__exp {
        @apply mx-1 text-center text-xs;
    }
    .pricing-plan-badge__exp__lifetime {
        @apply flex flex-row items-center gap-1 !important;
    }
    .pricing-plan-badge__exp__lifetime svg {
        @apply h-3 w-3 !important;
    }

    .pricing-plan-explanation {
        @apply text-xs font-light text-gray-500;
    }

    .price-modal-table__header {
        @apply grid grid-cols-4 gap-x-4 border-b border-t border-gray-200 bg-gray-100 p-4 text-sm font-medium text-gray-900;
    }
    .price-modal-table__header-cell {
        @apply flex flex-col items-center justify-center gap-2;
    }
    .price-modal-table__header-plan {
        @apply text-lg font-bold;
    }
    .price-modal-table__header-price {
        @apply text-5xl font-bold;
    }
    .price-modal-table__header-enterprise {
        @apply h-20 text-black;
    }
    .price-modal-table__header-subscription {
        @apply text-gray-600;
    }

    .price-modal-feature {
        @apply grid grid-cols-4 gap-x-16 border-b border-gray-200 px-8 py-4 text-sm text-gray-700 dark:border-gray-700;
    }
    .price-modal-feature__name {
        @apply flex flex-wrap items-center gap-1;
    }
    .price-modal-feature__comming-soon {
        @apply rounded-sm bg-yellow-200 px-2 py-1 text-center text-3xs font-bold leading-3 text-black;
    }
    .subscription-type {
        @apply relative z-0 flex h-fit max-w-28 cursor-pointer select-none items-center gap-1 self-center rounded-full border border-gray-200 bg-gray-100;
    }

    .subscription-type__placeholder {
        @apply absolute flex h-full w-full items-center justify-between px-2 text-gray-300;
    }

    .subscription-type__switch {
        @apply z-10 ml-0 w-20 rounded-full bg-gray-500 px-2 py-1 text-center text-white transition-all;
    }

    .subscription-type__switch--active {
        @apply translate-x-8;
    }

    .price-modal-feature__cell {
        @apply flex items-center justify-center;
    }
    .price-modal-feature__cell--clickable {
        @apply cursor-pointer select-none;
    }

    .selected {
        @apply font-extrabold text-black;
    }
</style>
